import { type BucketCategory } from 'investments/common/entities'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { type UseMutationRequestOptions, useMutationRequest } from '~/ui/hooks/utils/service/use-query-request'

type UpdateBucketParams = {
  accountId: string
  bucketId: string
  category?: BucketCategory
  name?: string
  targetAmount?: number
  targetDate?: string
}

async function updateBucket({ accountId, bucketId, category, name, targetAmount, targetDate }: UpdateBucketParams) {
  const { data } = await httpClientBanking<void>({
    url: `/investments/accounts/${accountId}/buckets/${bucketId}`,
    method: 'PATCH',
    data: {
      category,
      name,
      target_amount: targetAmount,
      target_date: targetDate
    }
  })
  return data
}

export function useUpdateBucket(config?: UseMutationRequestOptions<void, unknown, true, UpdateBucketParams>) {
  return useMutationRequest<void, unknown, true, UpdateBucketParams>(['useUpdateBucket'], updateBucket, config)
}
